import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faCheck, faCubes, faSliders, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { forkJoin } from 'rxjs';
import * as _ from 'underscore';
import { ErrorService } from '../../../../../../@core/utils/error.service';
import { ConfirmationDialogComponent } from '../../../../../../partials/content/widgets/general/confirmation-dialog/confirmation-dialog.component';
import { CropVariety } from '../../../../../core/models/crop-variety';
import { PlatformConfigService } from '../../../../../core/services/platform-config.service';
import { VarietyService } from '../../../../../core/services/variety.service';
import { KwFilterDropdownService } from '../../../../../core/widgets/kw-filter-dropdown/kw-filter-dropdown.service';
import { InventoryService } from '../../../../pick-plan/services/inventory.service';
import { HandlingUnitDetailDTO } from '../../../models/handling-unit-detail';
import { HandlingUnitMasterDTO } from '../../../models/handling-unit-master';
import { InventoryPackageTypeDTO } from '../../../models/inventory-package-type';
import { InventoryItemDTO } from '../../../models/item';
import { InventoryItemAttributeDTO } from '../../../models/item-attribute';
import { InventoryItemAttributeValueDTO } from '../../../models/item-attribute-value';
import { InventoryPackageTypeService } from '../../../services/inventory-package-type.service';

export interface InventoryItemPopupData {
  item?: InventoryItemDTO;
  isPopup?: boolean;
  isHumEdit?: boolean;
  hum?: HandlingUnitMasterDTO;
  hud?: HandlingUnitDetailDTO;
  isReturnBottomsheet?: boolean;
}

@Component({
  selector: 'inventory-item-edit',
  templateUrl: './inventory-item-edit.component.html',
  styleUrls: ['./inventory-item-edit.component.scss']
})

export class InventoryItemEditComponent implements OnInit {
  @ViewChild('itemInputForm', { static: true }) itemInputForm: NgForm;

  private destroyRef = inject(DestroyRef);

  static open(dialog: MatDialog, data: InventoryItemPopupData): MatDialogRef<InventoryItemEditComponent, InventoryItemDTO> {
    return dialog.open(InventoryItemEditComponent, { data, width: '760px', maxWidth: '95vw' });
  }

  // Optional: the legacy inventory-item-edit route renders this without a dialog.
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: InventoryItemPopupData,
    private activatedRoute: ActivatedRoute,
    private inventoryService: InventoryService,
    private packageTypeService: InventoryPackageTypeService,
    private router: Router,
    private dialogRef: MatDialogRef<InventoryItemEditComponent, InventoryItemDTO>,
    private dialog: MatDialog,
    private changeDetRef: ChangeDetectorRef,
    private filterService: KwFilterDropdownService,
    private location: Location,
    private varietyService: VarietyService,
    private errorService: ErrorService,
    private platformConfigService: PlatformConfigService,
  ) {
    this.data = data ?? {};
    this.getAllConfigValues();
    if (this.data.item)
      this.item = { ...this.data.item };
    else
      this.item = {};
  }

  // Icons  //
  public faXmark = faXmark;
  public faCubes = faCubes;
  public faSliders = faSliders;
  public faTrash = faTrash;
  public faCheck = faCheck;

  public item: InventoryItemDTO = {};
  public items: InventoryItemDTO[];
  public itemAttrabutes: InventoryItemAttributeDTO[];
  public varieties: CropVariety[];
  public isLoading: boolean = false;
  public packageTypes: InventoryPackageTypeDTO[] = [];
  public isREPToken: boolean = false;


  ngOnInit() {

    forkJoin([
      this.inventoryService.getInventoryItems(),
      this.varietyService.getVarieties(false),
      this.inventoryService.getInventoryItemAttributes(),
      this.packageTypeService.getAll()
      //this.roomService.getRooms()
    ])
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        this.items = _.sortBy(x[0], 'name').reverse();
        this.varieties = _.sortBy(x[1], 'name');
        this.itemAttrabutes = x[2];
        this.packageTypes = _.sortBy(x[3], 'name');
        //this.isLoading = false;
        this.activatedRoute.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
          if (params["itemId"]) {
            this.inventoryService.getInventoryItem(params["itemId"]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
              this.item = x;
              //this.isLoading = false;
            }, error:err => {
              this.errorService.handleError(err);
              //this.isLoading = false;
            }});
          }
          this.customFields();
          this.isLoading = false
        })
      }, error:err => {
        this.errorService.handleError(err);
        //this.isLoading = false;
      }});
  }

  submit() {
    //Pass saveERPFlag hardcoded true from Item create/update.
    let saveERPFlag = true;
    this.isLoading = true;

    if(this.item.parentItemId == 0)
      this.item.parentItemId = null;
      
    if (this.item.id) {
      this.inventoryService.putInventoryItem(this.item,saveERPFlag).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        // Keep the filter dropdown cache in sync so other pages show the change immediately
        this.filterService.upsertCached('inventoryItem', this.item);
        this.cancel();
      }, error:err => {
        this.errorService.handleError(err);
        this.isLoading = false;
        this.changeDetRef.detectChanges();
      }});
    }
    else {
      this.inventoryService.postInventoryItem(this.item,saveERPFlag).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        this.item.id = x.id;
        this.filterService.upsertCached('inventoryItem', this.item);
        this.cancel();
        this.isLoading = false;
      }, error:err => {
        this.isLoading = false;
        this.errorService.handleError(err);
        this.changeDetRef.detectChanges();
      }});
    }
  }

  typeSelectionChange(event: any) {
    
    let type = {...this.packageTypes.filter(x => x.id == event.value)[0]};
    this.item.packageTypeName = type.name;
  }


  cancel() {
    if (this.data.isPopup) {
      if (this.item.id) {
        // Add Product (or Create Inventory's Add Item section) is still open under this dialog;
        // it reloads products on close and reselects data.hud.itemId.
        if (this.data.isReturnBottomsheet)
          this.data.hud.itemId = this.item.id;
        this.dialogRef.close(this.item);
      }
      else {
        this.dialogRef.close();
      }
    }
    else
      this.location.back();
  }

  deleteItem() {
    const confRef = this.dialog.open(ConfirmationDialogComponent, {
      minWidth: '10%',
      data: {
        confirmLabel: 'Yes',
        title: 'Delete Product?',
        confirmMessage: 'Are you sure you want to delete this item?',
        cancelLabel: 'No'
      }
    }).afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {

      if (result === true) {
        this.isLoading = true;
        let erpSave = true;
        this.inventoryService.deleteInventoryItem(this.item.id,erpSave).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
          this.filterService.removeCached('inventoryItem', this.item.id);
          this.cancel();
        }, error:err => {
          this.errorService.handleError(err);
          this.isLoading = false;
        }});
      }
    });
  }


  customFields() {
    if (!this.item.attributes)
      this.item.attributes = [];

    this.itemAttrabutes.forEach(f => {

      var tempField = this.item.attributes.find(x => x.inventoryItemAttributeId == f.id);
      if (tempField) {
        tempField.description = f.description;
        tempField.name = f.name;
        tempField.inventoryItemId = this.item.id;
      }
      else {
        let fieldValue: InventoryItemAttributeValueDTO = {
          datatype: f.datatype,
          description: f.description,
          name: f.name,
          id: 0,
          inventoryItemAttributeId: f.id,
          isActive: true
        };
        this.item.attributes.push(fieldValue);
      }
    });
    this.changeDetRef.markForCheck();
  }

  getOptionsLength(attrabute: InventoryItemAttributeValueDTO) {
    if (this.itemAttrabutes)
      return this.itemAttrabutes.find(x => x.id == attrabute.inventoryItemAttributeId).options.length;
    else
      return [];

  }

  ClearValue(field) {
    var currentField = this.item.attributes.find(x => x.id == field.id);
    currentField.value = null;
  }

  getFieldName(field: InventoryItemAttributeValueDTO) {
    var currentField = this.itemAttrabutes.find(x => x.id == field.inventoryItemAttributeId);
    return currentField.name
  }

  getFieldOptions(field) {
    var currentField = this.itemAttrabutes.find(x => x.id == field.inventoryItemAttributeId);
    return currentField.options
  }

    //get ERPNext token from config
    getAllConfigValues() {
       this.isLoading = true;
      this.platformConfigService.getAllConfigValues().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        {next:(data) => {
          this.isLoading = false;
          if(!!data && data.length > 0){
            //set true if erp token present
            this.isREPToken = !!data.find(x=>x.name.includes("ERPNext:AccessToken")).value;
          }
        },
        error:(err) => {
          this.isLoading = false;
          this.errorService.handleError(err);
        }}
      );
      this.changeDetRef.markForCheck();
    }

}
